if (!customElements.get('scrolly-video-component')) {
    customElements.define(
      'scrolly-video-component',
      class ScrollyVideoComponent extends HTMLElement {
          constructor () {
              super();
              this.url = this.getAttribute('data-url');
              this.video = null;

          }
          connectedCallback() {
              if(this.url && this.video === null) {
                  this.video =  new CustomScrollyVideo({
                      scrollyVideoContainer: this,
                      src: this.url,
                      full: false,
                      cover: false,
                      trackScroll:false,
                      transitionSpeed:8,
                      frameThreshold: 0.1,
                  });
              }
          }
          disconnectedCallback() {
            if(this.video) {
              this.video.destroy();
              this.video = null;
            }
         }
      },
    );
}
